import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Component, DestroyRef, Inject, OnInit, inject } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormGroupDirective,
  NgForm,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import { ErrorStateMatcher } from '@angular/material/core';
import { WorkplaceTypeService } from '../../../services/workplace-type.service';
import { ToastAlertService } from '@core/services';
import { ButtonComponent } from '@shared/components/button/button.component';
import { NgIf } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { InputComponent } from '@shared/components/input/input.component';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { TitleComponent } from '@shared/components/title/title.component';
import { MatCardModule } from '@angular/material/card';

export class typeWorkplaceErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(
    control: FormGroup | null,
    form: FormGroupDirective | NgForm | null
  ): boolean {
    const isSubmitted = form && form.submitted;
    return !!(
      control &&
      control.invalid &&
      (control.dirty || control.touched || isSubmitted)
    );
  }
}

@Component({
  selector: 'app-workplace-type-create-modal',
  templateUrl: './workplace-type-create-modal.component.html',
  standalone: true,
  imports: [
    MatCardModule,
    TitleComponent,
    MatButtonModule,
    MatTooltipModule,
    MatIconModule,
    ReactiveFormsModule,
    MatDialogContent,
    InputComponent,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    NgIf,
    MatDialogActions,
    ButtonComponent,
    MatDialogClose,
  ],
})
export class WorkplaceTypeCreateModalComponent implements OnInit {
  private formBuilder = inject(FormBuilder);
  public operation: string = '';
  public workplaceTypeForm!: FormGroup;
  matcher = new typeWorkplaceErrorStateMatcher();
  private workPlaceTypeService = inject(WorkplaceTypeService);
  private dialogRef = inject(MatDialogRef<WorkplaceTypeCreateModalComponent>);
  private alertService = inject(ToastAlertService);
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
  private destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    console.log(this.data);
    if (this.data.action?.workplacetypeid) {
      this.operation = 'Modificar';
      this.workplaceTypeForm = this.formBuilder.group({
        workplacetypeid: [this.data.action?.workplacetypeid],
        name: [this.data.action?.name, Validators.required],
        isparking: [
          this.data.action?.isparking === '1' ? true : false,
          Validators.required,
        ],
        description: [this.data.action?.description, Validators.required],
        recurrence: [
          this.data.action?.recurrence,
          [Validators.required, Validators.pattern('^[1-7]$')],
        ],
        maxcapacity: [
          this.data.action?.maxcapacity,
          [Validators.required, Validators.min(1)],
        ],
      });
    } else {
      this.operation = 'Crear';
      this.workplaceTypeForm = this.formBuilder.group({
        workplacetypeid: ['0'],
        name: ['', Validators.required],
        isparking: [false, Validators.required],
        description: ['', Validators.required],
        recurrence: ['', [Validators.required, Validators.pattern('^[1-7]$')]],
        maxcapacity: ['', [Validators.required, Validators.min(1)]],
        businessid: [''],
      });
    }
  }

  get id_workplaceType() {
    return this.workplaceTypeForm.get('workplacetypeid');
  }
  submit() {
    if (this.id_workplaceType?.value == 0) {
      this.storeWorkplaceType();
    } else {
      this.updateWorkplaceType();
    }
  }

  private storeWorkplaceType() {
    if (this.workplaceTypeForm.valid) {
      if (this.workplaceTypeForm.get('isparking')?.value == true) {
        this.workplaceTypeForm.get('isparking')?.setValue(1);
      } else {
        this.workplaceTypeForm.get('isparking')?.setValue(0);
      }

      this.workplaceTypeForm.value.businessid = this.data.businessId;

      console.log(this.workplaceTypeForm.value);

      this.workPlaceTypeService
        .storeWorkplace(this.workplaceTypeForm.value)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: resp => {
            console.log(resp);
            if (resp.code === 10000) {
              this.dialogRef.close(true);
              this.alertService.sucess('Tipo de trabajo creado');
            } else {
              this.alertService.error(resp.detail);
            }
          },
        });
    }
  }

  private updateWorkplaceType() {
    if (this.workplaceTypeForm.valid) {
      if (this.workplaceTypeForm.get('isparking')?.value == true) {
        this.workplaceTypeForm.get('isparking')?.setValue(1);
      } else {
        this.workplaceTypeForm.get('isparking')?.setValue(0);
      }
      console.log(this.workplaceTypeForm.value);
      this.workPlaceTypeService
        .updateWorkplace(
          this.workplaceTypeForm.value,
          Number(this.id_workplaceType?.value)
        )
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: resp => {
            if (resp.code === 10000) {
              this.dialogRef.close(true);
              this.alertService.sucess('Tipo de trabajo modificado');
            } else {
              this.alertService.error(resp.detail);
            }
          },
        });
    }
  }

  clearForm() {
    this.ngOnInit();
  }
}
